// Array.filter polyfill
if (Array.prototype.filter === undefined) {
  /* eslint-disable no-extend-native */
  Array.prototype.filter = (fn) => {
    const rv = [];
    /* eslint-disable no-plusplus */
    for (let i = 0, l = this.length; i < l; i++) { if (fn(this[i])) rv.push(this[i]); }

    return rv;
  };
}



// WEBPACK FOOTER //
// ./src/common/js/polyfills.js